'use client';

import React from 'react';

import { RadioTile, RadioTiles, Row, Text, TextLevels, TypographyBold } from '@bytel/trilogy-react';

import { ProductChildFull, ProductFeatureType, ProductParentFull } from '@app-types/product';

type CustomizationCategoryProps = {
    title: string;
    features: ProductParentFull['features'];
    featuresRules: ProductParentFull['featuresRules'];
    currentProduct: ProductChildFull;
    handleProductChange: (color: string, capacity?: string) => void;
    featuresKey: ProductFeatureType;
};

export function CustomizationCategory({
    title,
    features,
    featuresRules,
    currentProduct,
    handleProductChange,
    featuresKey,
}: Readonly<CustomizationCategoryProps>) {
    const onChange = (value: string) => {
        if (featuresKey === ProductFeatureType.COLOR) {
            handleProductChange(value, currentProduct?.capacity);
        } else {
            handleProductChange(currentProduct.color, value);
        }
    };

    return (
        <Row>
            <Text level={TextLevels.ONE} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                {title}
            </Text>
            <RadioTiles className='grid-radio-list'>
                {features[featuresKey].map((feature) => {
                    const featureName = feature.name;
                    const isDisabled =
                        featuresKey === ProductFeatureType.CAPACITY &&
                        !featuresRules[currentProduct.color]?.includes(featureName);

                    return (
                        <RadioTile
                            id={featureName}
                            key={featureName}
                            label={featureName}
                            name={featuresKey}
                            value={featureName}
                            checked={featureName === currentProduct[featuresKey]}
                            horizontal
                            disabled={isDisabled}
                            onChange={({ radioValue }) => onChange(radioValue)}
                        />
                    );
                })}
            </RadioTiles>
        </Row>
    );
}
